// src/pages/support/GiftsOfStock.js
import React from "react";
import { Helmet } from "react-helmet";
import dummyImage from "../../assets/images/support/stock.webp";
import CTASection from "../../components/CTASection"; // Add CTASection import
import styled from "styled-components"; // Add styled-components
import SupportOpportunity from "../../components/SupportOpportunity";

const GiftsOfStock = () => {
  const description = `
    Donating appreciated stocks, bonds, or mutual funds is an excellent way to support Habitat for Humanity Buffalo. By giving stocks directly, you can avoid capital gains taxes and potentially receive a charitable deduction for the full value of the stock.
  `;

  const waysToSupport = [
    "Contact your financial advisor",
    "Transfer stocks directly to Habitat Buffalo",
    "Discuss with our team for specific instructions",
  ];

  return (
    <>
      <Helmet>
        <title>Gifts of Stock - Habitat for Humanity Buffalo</title>
        <meta
          name="description"
          content="Support Habitat Buffalo by donating appreciated stocks, bonds, or mutual funds. Avoid capital gains taxes and receive a charitable deduction."
        />
      </Helmet>
      <Container>
        <SupportOpportunity
          title="Gifts of Stock"
          image={dummyImage}
          description={description}
          waysToSupport={waysToSupport}
        />
        {/* Add CTA Section */}
        <CTASection
          title="Start Your Stock Donation"
          description="Ready to make a lasting impact? Click the button below to get started with your stock donation."
          buttonText="Get Started"
          buttonLink="/form/giving"
        />
      </Container>
    </>
  );
};

// Add necessary styled components
const Container = styled.div`
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
`;

export default GiftsOfStock;
